import getOverlapsOfPotentiallyCircularRanges from "./getOverlapsOfPotentiallyCircularRanges";
import collapseOverlapsGeneratedFromRangeComparisonIfPossible from "./collapseOverlapsGeneratedFromRangeComparisonIfPossible";
import zeroSubrangeByContainerRange from "./zeroSubrangeByContainerRange";
import normalizePositionByRangeLength from "./normalizePositionByRangeLength";
export default function getZeroedRangeOverlaps(annotation, selection, sequenceLength) {
  const overlaps = collapseOverlapsGeneratedFromRangeComparisonIfPossible(
    getOverlapsOfPotentiallyCircularRanges(
      annotation,
      selection,
      sequenceLength
    ),
    sequenceLength,
    annotation
  );
  const zeroedOverlaps = overlaps.map((overlap) => {
    return zeroSubrangeByContainerRange(
      overlap,
      {
        start: selection.start,
        end: normalizePositionByRangeLength(selection.start - 1, sequenceLength)
      },
      sequenceLength
    );
  });
  return zeroedOverlaps;
}
